<template>
  <div>
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('parametrage.title') }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <form @submit.prevent="recherche()" class="columns mgt-10px">
      <b-field class="column is-narrow">
        <b-input :placeholder="$t('parametrage.actions.search')"
                 type="search" icon="magnify" @input="recherche()"
                 class="inputSearch" v-model="search">
        </b-input>
      </b-field>
    </form>
    <div v-for="(section, $index) in listeSection" :key="$index">
      <div class="columns mgt-20px">
        <div class="column is-narrow is-size-4 has-text-link has-text-weight-bold">
          {{ $t(section.name) }}
        </div>
      </div>
      <div class="columns is-multiline parametrage">
        <div :class="[item.actif ? 'column is-narrow' : '']"
             v-for="(item, index) in section.items.filter(item => item.show)"
             :key="index" :disabled="item.actif">
          <div v-if="item.actif">
            <router-link :to="{ name: item.routeName }"
                        :class="{'text-access-no-permission':
                                    !checkPermissions(item.perm) || !item.actif}">
              <div class='card'>
                <div class='card-image pd-10px box-shadow-card'
                    :class="{'opacity-low' : !item.actif}">
                  <div class="image" :class="item.class"></div>
                </div>
              </div>
              <p class="has-text-centered mgt-10px is-size-6 width-libelle-icon">
                {{ $t(item.libelle) }}
              </p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import genererSectionParametrage from '@/services/parametrage/generation/genererSectionParametrage';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import cloneDeep from 'lodash/cloneDeep';

const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      listeSectionBase: [],
      search: '',
      listeSectionRecherche: [],
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    breadcrumb() {
      return [
        { title: this.$t('parametrage.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('parametrage.title'), route: { name: 'l.parametrage.general' }, isActive: true },
      ];
    },
    listeSection() {
      return this.listeSectionRecherche
        .filter(section => section.items.filter(item => item.show && item.actif).length > 0);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    recherche() {
      this.listeSectionBase.forEach((section) => {
        section.items.forEach((sousCategorie) => {
          const libelleSousCat = this.$i18n.t(sousCategorie.libelle).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
          sousCategorie.actif = libelleSousCat.toLowerCase()
            .includes(this.search.toLowerCase());
        });
      });
      this.listeSectionRecherche = cloneDeep(this.listeSectionBase);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.setInformationPage(this.$t('pageParametrage.parametrage.liste'));
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key,
        PARAMETRES_INTERNE_KEYS.modulePresse.key,
        PARAMETRES_INTERNE_KEYS.signatureElectronique.key,
        PARAMETRES_INTERNE_KEYS.produitPresse.key,
        PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
        PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key,
        PARAMETRES_INTERNE_KEYS.produitSponsoring.key,
      ]);
      this.listeSectionBase = genererSectionParametrage();
      this.listeSectionRecherche = cloneDeep(this.listeSectionBase);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
